import { OfferStatus } from './offers.enums';

export const jobStatusTranslationKeys = {
  [OfferStatus.Draft]: 'app.offers.status.draft',
  [OfferStatus.Published]: 'app.offers.status.published',
  [OfferStatus.Internal]: 'app.offers.status.internal',
  [OfferStatus.Closed]: 'app.offers.status.closed',
  [OfferStatus.Archived]: 'app.offers.status.archived',
};
